import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { Icon } from '@calendly/ui/components/icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
const extensionBannerWrapperCss = "e1nb4xrn";
export const ExtensionBannerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(extensionBannerWrapperCss, props.className)} />;
});
const logoWrapperCss = "l1l4hxbp";
export const LogoWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoWrapperCss, props.className)} />;
});
const logoBackgroundCss = "lttza73";
export const LogoBackground = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoBackgroundCss, props.className)} />;
});
const styledLogoCss = "s1u5wp2l";
export const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
const textWrapperCss = "t1hrf11f";
export const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
const styledCloseIconCss = "s147n01y";
export const StyledCloseIcon = forwardRef((props, ref) => <Icon ref={ref} {...props} className={classNames(styledCloseIconCss, props.className)} />);

require("./components.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./components.js");